<template>
  <div class="modal fade" id="addServiceMinutesModal">
    <div v-if="student != null" class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Add Service Minutes</h5>
          <button
            type="button"
            class="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body text-left">
          <label v-if="errorMessage != ''" class="text-danger">{{
            errorMessage
          }}</label>
          <transition
            name="slide-fade"
            mode="out-in"
          >
            <form key="minutes" @submit.prevent="createServiceMinutes">
              <h4>{{ student.get("name") }}</h4>
              <div class="form-group">
                <label v-bind:for="'date' + student.id">Date</label>
                <input
                  type="date"
                  class="form-control"
                  v-bind:id="'date' + student.id"
                  v-model="date"
                  required
                />
              </div>
              <div class="form-group">
                <label for="service">Service</label>
                <select
                  id="service"
                  name="servicePicker"
                  class="form-control selectpicker"
                  data-style="btn-outline-primary"
                  data-none-selected-text="Select Service..."
                  data-actions-box="true"
                  v-model="selectedService"
                  required
                >
                <option v-for="service in studentServices" v-bind:key="service.id" v-bind:value="service">{{ service.get("name") }}</option>
                </select>
              </div>
              <div class="form-group">
                <label for="minutes">Minutes</label>
                <input
                  type="number"
                  class="form-control"
                  id="minutes"
                  placeholder="Minutes"
                  v-model="minutes"
                  required
                />
              </div>
              <div class="form-group">
                <label for="notes">Notes</label>
                <input
                  type="text"
                  class="form-control"
                  id="notes"
                  placeholder="Notes..."
                  v-model="notes"
                  required
                />
              </div>
              <div class="text-right">
                <button type="submit" class="btn btn-primary">
                  Create Service Minutes
                </button>
              </div>
            </form>
          </transition>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import $ from "jquery";
import Parse from "parse";

export default {
  name: "AddServiceMinutesModal",
  props: {
    Student: Object,
    User: Object,
    Services: Array
  },
  data() {
    return {
      minutes: "",
      notes: "",
      errorMessage: "",
      user: this.User,
      student: this.Student,
      services: this.Services,
      studentServices: [],
      selectedService: null,
      date: this.$dateToYYYYMMDD(new Date())
    };
  },
  watch: {
    Student: function() {
      if(this.Student != null){
        this.student = this.Student;
        var studentServices = this.Student.get("services").map(s => s.service)
        if(studentServices != undefined){
          this.studentServices = this.services.filter(s => studentServices.includes(s.id))
        } else{
          this.studentServices = []
        }
      }
    },
    User: function() {
      this.user = this.User;
    },
    Services: function() {
      this.services = this.Services;
    }
  },
  mounted() {
    $("#addServiceMinutesModal").on("shown.bs.modal", function() {
      $(".selectpicker").selectpicker("refresh");
    });
  },
  methods: {
    async createServiceMinutes() {
      $("#addServiceMinutesModal").modal("hide");
      var view = this;
      view.$store.commit("updateLoading", true);

      var serviceMinutesToCreate = new Parse.Object("ServiceMinutes");
      serviceMinutesToCreate.set("minutes", parseInt(view.minutes));
      serviceMinutesToCreate.set("services", view.notes);
      serviceMinutesToCreate.set("receivedService", this.selectedService.id)
      serviceMinutesToCreate.set("userName", view.user.get("firstName") + " " + view.user.get("lastName"));
      serviceMinutesToCreate.set("studentId", view.student.id);
      serviceMinutesToCreate.set("studentName", view.student.get("name"));
      serviceMinutesToCreate.set("userId", view.user.id);
      serviceMinutesToCreate.set("date", new Date(view.date));

      var acl = new Parse.ACL(view.user)
      acl.setRoleWriteAccess(view.student.get("schoolName"), true);
      acl.setRoleReadAccess(view.student.get("schoolName"), true);

      serviceMinutesToCreate.setACL(acl);
      serviceMinutesToCreate.save()
      .then(() => {
        view.clearFields();
        view.$emit("service-minutes-added", view.student);
        view.$store.commit("updateLoading", false);
      }, (error) => {
        this.errorMessage = error.message;
        $("#addServiceMinutesModal").modal("show");
        view.$store.commit("updateLoading", false);
      });
    },
  
    clearFields() {
      this.minutes = "";
      this.notes = "";
      this.errorMessage = "";
      this.selectedService = null;
      this.date = this.$dateToYYYYMMDD(new Date())
    }
  }
};
</script>
